var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.15 10.5332C19.15 9.89808 18.6351 9.3832 18 9.3832C17.3649 9.3832 16.85 9.89808 16.85 10.5332L19.15 10.5332ZM17.1868 27.2796C17.6359 27.7287 18.3641 27.7287 18.8132 27.2796L26.1317 19.961C26.5808 19.5119 26.5808 18.7838 26.1317 18.3347C25.6826 17.8856 24.9545 17.8856 24.5054 18.3347L18 24.8401L11.4946 18.3347C11.0455 17.8856 10.3174 17.8856 9.86827 18.3347C9.41917 18.7838 9.41917 19.5119 9.86827 19.961L17.1868 27.2796ZM16.85 10.5332L16.85 26.4664L19.15 26.4664L19.15 10.5332L16.85 10.5332Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.b7264e16.svg";
export { ForwardRef as ReactComponent };